import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
/**
 * @Description This function returns Deploy dialog.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function DeployDialog({ setOpen }) {
    const { t } = useTranslation();
    const location = useLocation();
    const label = 'CONTENT.VARIANTS.';
    const handleClick = () => {
        setOpen(false);
    }
    return (
        <Dialog open>
            <div className="vdeploy">
                <button onClick={handleClick}>{t(label + 'ANONYMOUS')}</button>
                <Link to={`/login?to=/autom-store${location.pathname}`}>{t(label + 'REGISTERED')}</Link>
            </div>
        </Dialog>
    )
}
export default DeployDialog;